import React from 'react';
import {useNavigation, useRoute} from '@react-navigation/native';

import {CheckoutSession} from '../../../components/shared/Payments/CheckoutSession';
import {Emprestimo} from '../../../components/shared/Payments/CheckoutSession/modules/Emprestimo';
import {RootStackParamList} from '../../../dtos/RoutesDTO';

export function EmprestimoPagamento() {
  const navigation = useNavigation();
  const route = useRoute();

  const {
    operacao_mova_id,
    parcela_mova_id,
    tipo_operacao,
    numero_parcela,
    data_vencimento,
    valor_centavos,
  } = route.params as RootStackParamList['EmprestimoPagamento'];

  const valorReais = valor_centavos / 100;

  return (
    <CheckoutSession
      enableDiscounts={false}
      enableBaratinhas={false}
      enableVale={false}
      enableCCT={false}
      enableBrbDiscount={false}
      showReferAndWinButton={false}
      enablePendingPayment={false}
      onGoBack={() => navigation.goBack()}
      module={
        <Emprestimo
          operacao_mova_id={operacao_mova_id}
          parcela_mova_id={parcela_mova_id}
          tipo_operacao={tipo_operacao}
          numero_parcela={numero_parcela}
          data_vencimento={data_vencimento}
          value={valorReais}
        />
      }
    />
  );
}
